import {Fragment, useEffect, useState} from 'react';
import axios from 'axios';
//import DeviceListMaster from './deviceMasterList.json'
import XfinityDevices from './xfinity/XfinityDevices';
import "./xfinity/xfinity.css";

export default function XfinityList() {
  const [index, updateIndex] = useState(null);
  const [deviceListData, updateData] = useState({});
  const [ready, updateReady] = useState(false);
  
  async function getIndexes(){
    let data = {}
    let dataURL = '';
    await axios.get(`${window.origin}/wp-json/wp/v2/posts/4830`)
      .then(res =>{
        dataURL = res.data.content.rendered
        dataURL = dataURL.substring(3, dataURL.indexOf('<', 3))
      })
    await axios.get(dataURL)
      .then(res => {
        dataURL = res.data.guid.rendered
      })
    await axios.get(dataURL) // api call
        .then(res => {
          data = res.data
          updateData(res.data)
        })
    Object.keys(data).forEach(category => {
      if(category === 'Xfinity Streaming Devices' || category === 'Xfinity Mobile Devices'){
        data[category].forEach(item => {
          updateIndex(index => ({...index, [item["Brand"] + ' ' + item["Device Model/Series"]]:[item, category]}));
        })
      }
    })
    updateReady(true);
  };

  useEffect(() => {
    if(ready === false ){
      getIndexes();
    }
  }, [ready])

  return (
    <Fragment>
      {ready === true && <XfinityDevices jsonData={deviceListData} index={index}/>}
    </Fragment>
  );
}